import { Paginated, Sortable } from "@ac-expo/api-types";

export type ConsentsFilter = {
  searchText?: string;
} & Sortable<Paginated>;

export const consentQueryKeys = {
  all: ["consent"] as const,
  mine: () => [...consentQueryKeys.all, "mine"],
  lists: (filters?: Sortable<Paginated<ConsentsFilter>>) => [
    ...consentQueryKeys.all,
    "lists",
    filters,
  ],
  getConsent: (organiserId?: string, structureId?: string, userId?: string) => [
    ...consentQueryKeys.all,
    "getConsent",
    organiserId,
    structureId,
    userId,
  ],
  getConsentWithMultipleProfesionnals: (
    organiserIds: string[] = [],
    structureIds: string[] = []
  ) => [
    ...consentQueryKeys.all,
    "getConsentWithMultipleProfesionnals",
    ...organiserIds,
    ...structureIds,
  ],
  history: (filters?: Sortable<Paginated<ConsentsFilter>>) => [
    ...consentQueryKeys.all,
    "history",
    filters,
  ],
};
